<template>
  <div>
    <el-dialog
      class="info_auto_modal"
      title="Паспорт автомобиля"
      :visible.sync="dialogVisible"
      :width="widthDialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      @closed="setNull"
    >
      <el-row :gutter="24">
        <el-col :span="24">
          <p>
            Номер авто: <b>{{ autoSet.plate }}</b>
          </p>
          <p v-if="isOwn"><b>Собственный транспорт</b></p>
          <p v-if="!isOwn"><b>Наемный транспорт</b></p>
          <p>
            Основание: <b>{{ reasonName }}</b>
          </p>
        </el-col>
      </el-row>
      <el-row v-if="isApproved" :gutter="12">
        <el-col :span="12">
          <p>
            <el-alert
              title="Автомобиль проверен администратором"
              type="success"
              effect="dark"
              :closable="false"
            />
          </p>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <h2>Данные по автомобилю</h2>
        </el-col>
      </el-row>
      <slot />
      <el-form ref="form" :model="autoSet" @submit.native.prevent>
        <el-row>
          <el-col :xs="24" :sm="12">
            <el-form-item prop="vehicle_type_id">
              <span>Выбор типа авто:</span>
              <el-select
                v-model="autoSet.vehicle_type_id"
                placeholder="Выберите"
              >
                <el-option
                  v-for="item in autoTypes"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <set-carrier
          v-if="!isOwn || canAction('action_set_reason') || isDriverRole"
          :auto="autoSet"
          :read-only="isApproved"
          @changed="changed"
        />
        <file-sts
          ref="trucksFiles"
          :auto="autoSet"
          :edited="true"
          @savedAdvanced="savedAdvanced"
        />
        <sts-truck :auto="autoSet" :read-only="isApproved" @changed="changed" />
        <el-row :gutter="24">
          <el-col :span="24">
            <h2>Данные по прицепу</h2>
          </el-col>
        </el-row>
        <sts-trailer
          :auto="autoSet"
          :read-only="isApproved"
          @changed="changed"
        />
        <file-sts-trailer ref="trailerFiles" :auto="autoSet" />
        <el-row :gutter="24">
          <el-col :span="24">
            <div style="text-align: left">
              <el-button
                v-if="!isApproved"
                style="margin-top: 12px"
                type="primary"
                @click="updateAuto"
              >
                Сохранить авто и прицеп
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <accreditation-wrapper
        v-if="canAction('see_master_approve_wrapper')"
        :entity-id="editAuto.id"
        :link-by-rel="automobiles"
        @updateStore="updateStore"
      />
    </el-dialog>
  </div>
</template>

<script>
import { APPROVEMENTS_AUTO } from '@/store/actions/approvements'
import { DEFAULT_VIN_VALUE } from '@/datas/consts'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { filesValidateMixinParentActions } from '@/mixins/filesValidateMixin'
import { mapGetters, mapMutations } from 'vuex'
import AccreditationWrapper from '@/components/Accreditation/AccreditationWrapper'
import Auto from '@/datas/Autos'
import FileSts from './Forms/FileSts'
import FileStsTrailer from './Forms/FileStsTrailer'
import SetCarrier from './Forms/SetСarrier'
import StsTrailer from './Forms/StsTrailer'
import StsTruck from './Forms/StsTruck'
import getError from '@/api/getErrors'

const AutoRepository = RepositoryFactory.get('auto')

export default {
  name: 'AutoEdit',
  components: {
    AccreditationWrapper,
    FileStsTrailer,
    SetCarrier,
    StsTrailer,
    StsTruck,
    FileSts,
  },
  mixins: [filesValidateMixinParentActions],
  props: {
    editAuto: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      automobiles: 'automobiles',
      dialogVisible: false,
      autoSet: { id: 0 },
      reason: 0,
      reasons: [
        { id: 1, name: 'Собственность (указан в СТС)' },
        { id: 2, name: 'Лизинг' },
        { id: 4, name: 'Аренда' },
      ],
      isApprove: false,
    }
  },
  computed: {
    ...mapGetters({ autoTypes: 'autos/getAutoTypes' }),
    widthDialog() {
      return this.isMobile ? '100%' : '60%'
    },
    isApproved() {
      return this.isApprove || Number(this.autoSet.isAprove) === 1
    },
    isOwn() {
      return this.editAuto.user_org_inn === this.editAuto.inn_owner
    },
    reasonName() {
      const ret = this.reasons
      const reason = this.autoSet.isOwner
      const temp = ret.filter(data => Number(data.id) === Number(reason))

      if (temp.length > 0) {
        return temp[0].name
      }

      return 'Ошибка'
    },
  },
  watch: {
    editAuto: {
      handler(newVal) {
        if (newVal.id && newVal.id !== 0) {
          this.dialogVisible = true
          let auto = new Auto(this.editAuto)

          this.autoSet = auto.onlyValue()
          this.autoSet.vehicle_type_id = this.autoSet.vehicle_type_id || 1
          this.reason = this.editAuto.is_owner
        }
      },
    },
  },
  methods: {
    ...mapMutations({ setApprovementsAuto: `autos/${APPROVEMENTS_AUTO}` }),
    savedAdvanced(data) {
      this.changed(data)
      this.updateAuto()
    },
    updateStore(data) {
      this.setApprovementsAuto(data)
    },
    changed(data) {
      // TODO валидация формы
      //  this.$emit("changed", this.returnData);
      for (let item in data) {
        this.autoSet[item] = data[item]
      }
    },
    isErrors(data) {
      let error = getError.isError(data)

      if (error.isError) {
        this.$alert(error.message)

        return true
      }

      return false
    },
    approve() {
      this.$confirm(
        'Вы уверены что все данные проверены и соответствуют требованиям',
        'Warning',
        {
          confirmButtonText: 'Да',
          cancelButtonText: 'Нет',
          type: 'warning',
        },
      )
        .then(() => {
          AutoRepository.approve(this.editAuto.id, 1)
            .then(() => {
              this.$alert('Авто подтверждено успешно.', {
                customClass: this.isMobile ? 'classAlertError' : '',
              })
              this.isApprove = true
            })
            .catch(err => console.log(err))
        })
        .catch(() => {})
    },
    checkVINValue() {
      let tempVIN = this.autoSet.vin

      if (!tempVIN || [DEFAULT_VIN_VALUE, ''].includes(tempVIN.trim())) {
        this.autoSet.vin = null
      }
    },
    updateAuto() {
      let flag = true

      if (!this.isApproved) {
        flag = false
        this.$refs['form'].validate(valid => {
          if (valid) {
            flag = true
          }
        })
      }
      if (this.autoSet.sts_date && this.autoSet.sts_date.includes('.')) {
        this.autoSet.sts_date = this.dateToFormat(
          this.autoSet.sts_date,
          'defaultDate',
          1,
        )
      }
      if (
        flag &&
        this.checkCountFilesBeforeSave(['trucksFiles', 'trailerFiles'])
      ) {
        let successMessage = 'Авто обновлено успешно.'

        this.checkVINValue()
        AutoRepository.updateAutoFromData(this.autoSet.id, this.autoSet)
          .then(response => {
            if (!this.isErrors(response)) {
              this.$alert(successMessage, {
                customClass: this.isMobile ? 'classAlertError' : '',
              })
              this.dialogVisible = false
              this.$emit('updated', {
                data: response.model,
                idAuto: this.idAuto,
              })
            }
          })
          .catch(error => this.errHandler(error))
      }
    },
    setNull() {
      this.$emit('closedCustom')
    },
  },
}
</script>

<style lang="sass">
.info_auto_modal
  font-family: "Rubik", sans-serif
  .classAlertError
    width: 100% !important
  .el-dialog
    margin-top: 3vh !important
  .el-dialog__body
    padding-top: 0 !important
  .el-dialog__body
    padding: 0 20px 40px 20px
</style>
